import { render, staticRenderFns } from "./BusinessPartners.vue?vue&type=template&id=02d3a944&"
import script from "./BusinessPartners.vue?vue&type=script&lang=js&"
export * from "./BusinessPartners.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports